import $apiPrivate from 'api/apiPrivate'

const getUser = async () => {
  const response = await $apiPrivate.get('/user/auth');
  return response
}

export default {
  getUser,
}